import { IFixedPhraseFolderContent } from ".";

export interface IFixedPhraseFolderRootContent {
  tableId: string;
  templateId: string;
  folders: IFixedPhraseFolderContent[];
}

export function instanceOfIFixedPhraseFolderRootContent(instance: any): instance is IFixedPhraseFolderRootContent {
  return instance
    && (instance.tableId !== undefined)
    && (instance.templateId !== undefined)
    && (instance.folders !== undefined);
}
